import {Module} from '@fantasmagames/slot/src/common/Module';
import {BetButtonEvents} from '@fantasmagames/slot/src/modules/keypad/bet/BetButtonEvents';
import {BetlevelMenuViewEvents} from '@fantasmagames/slot/src/modules/popupmenus/betmenu/BetlevelMenuViewEvents';
import {BetlevelMenuEvents} from '@fantasmagames/slot/src/modules/popupmenus/betmenu/BetlevelMenuEvents';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';
import {BetlevelMenuView} from '@fantasmagames/slot/src/modules/popupmenus/betmenu/BetlevelMenuView';
import {BetlevelMenuBasicState} from '@fantasmagames/slot/src/modules/popupmenus/betmenu/states/BetlevelMenuBasicState';
import {BetlevelMenuOpenState} from '@fantasmagames/slot/src/modules/popupmenus/betmenu/states/BetlevelMenuOpenState';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {AutoplayMenuEvents} from '@fantasmagames/slot/src/modules/popupmenus/autoplaymenu/AutoplayMenuEvents';

export class BetlevelMenuModule extends Module<BetlevelMenuView> {
	public static readonly BASIC: string = 'BASIC';
	public static readonly OPEN: string = 'OPEN';

	protected setupStates(): void {
		this.addState(new BetlevelMenuBasicState(this, BetlevelMenuModule.BASIC));
		this.addState(new BetlevelMenuOpenState(this, BetlevelMenuModule.OPEN));
	}

	protected enterFirstState(): void {
		this.changeStateTo(BetlevelMenuModule.BASIC);
	}

	protected setupViews(): void {
		if (this.system.shouldUseMultipleViews()) {
			this.setView(Views.BET_LEVEL_MENU_VIEW_MOBILE);
		} else {
			this.setView(Views.BET_LEVEL_MENU_VIEW);
		}
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(AutoplayMenuEvents.TRIGGER_BET_MENU, this.onAutplayTriggerBetMenu);

		this.on(BetButtonEvents.BET_BUTTON_CLICKED, this.onBetButtonClicked);
		this.on(LogicEvents.INIT_RESPONSE, this.onInitResponse);
		this.on(ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted);

		this.onView(BetlevelMenuViewEvents.ACCEPTED, this.onAccepted);
		this.onView(BetlevelMenuViewEvents.CANCELLED, this.onCancelled);

		this.onViewEmitEvent(BetlevelMenuViewEvents.BET_LEVEL_MENU_CLOSED, BetlevelMenuEvents.BET_LEVEL_MENU_CLOSED);
		this.onViewEmitEvent(BetlevelMenuViewEvents.BET_LEVEL_MENU_OPENED, BetlevelMenuEvents.BET_LEVEL_MENU_OPENED);
	}

	protected onSpinStarted(): void {
		if (this.view.isVisible()) {
			this.view.hide();
		}
	}

	protected onAccepted(): void {
		this.logic.killRestore();
		this.updateBet();
		this.eventManager.emit(BetlevelMenuEvents.BET_LEVEL_MENU_SELECTED_BET_ACCEPTED);
		this.gotoState(BetlevelMenuModule.BASIC);
	}

	protected onCancelled(): void {
		this.resetButton();
		this.eventManager.emit(BetlevelMenuEvents.BET_LEVEL_MENU_CANCELLED);
		this.gotoState(BetlevelMenuModule.BASIC);
	}

	protected resetButton(): void {
		this.view.restoreToLastBet(this.view.lastBet);
	}

	protected updateBet(): void {
		this.logic.betValue = this.view.betValue ? this.view.betValue : 1;

		if (this.logic.betValue !== this.view.betValue) {
			// Added if there is a validation in logic which doesn't allow that value to be set.
			this.view.betValue = this.logic.betValue;
			this.view.restoreToLastBet(this.view.betValue);
		}

		this.saveData();
		this.eventManager.emit(BetlevelMenuEvents.BET_VALUE_UPDATED);
	}

	protected saveData(): void {
		if (this.canSaveData) {
			this.logic.saveData();
		}
	}

	protected get canSaveData(): boolean {
		return true;
	}

	protected onAutplayTriggerBetMenu(): void {
		this.openMenu();
	}

	protected onBetButtonClicked(): void {
		this.openMenu();
	}

	protected openMenu(): void {
		this.gotoState(BetlevelMenuModule.OPEN);
	}

	protected onInitResponse(): void {
		// TODO: Verify Bet value against init data.
		this.view.buttonValues = this.logic.betValues;
		this.view.defaultBet = this.logic.defaultBetValue;

		if (this.logic.lastBet) {
			this.view.lastBet = this.logic.lastBet;
			this.view.betValue = this.logic.betValue;
		} else {
			this.view.lastBet = this.logic.defaultBetValue;
			this.view.betValue = this.logic.defaultBetValue;
		}
		this.updateBet();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/popupmenus/betmenu/BetlevelMenuModule.ts